import { FixedPartyEnum } from '@zurich/api/party';
import { createStringEnumUtils, UnknownType } from '@zurich/common/utils';
export const fixedPartyUtils = createStringEnumUtils(FixedPartyEnum, {
    unknownType: UnknownType.STRING,
    translationPrefix: 'party:fixedParty',
});
